<script setup lang="ts">
import { ref } from 'vue'
import { Icon } from '@iconify/vue'
import { RouterLink } from 'vue-router'

const props = defineProps<{
  label: string
  icon: string
  children: any[]
  isExpanded: boolean
}>()

const isOpen = ref(false)
const toggle = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div>
    <div
      @click="toggle"
      class="px-6 py-4 hover:bg-gray-100 rounded-lg cursor-pointer flex justify-between items-center text-gray-700 text-sm font-normal"
    >
      <div class="flex items-center gap-2">
        <Icon :icon="icon" class="text-2xl text-gray-500 " />
        <span v-if="isExpanded" class="text-gray-500 font-normal ml-1 uppercase text-sm">
        {{ label }}
        </span>
      </div>
      <Icon
        :icon="isOpen ? 'ic:round-arrow-drop-up' : 'ic:round-arrow-drop-down'"
        v-if="isExpanded"
        class="text-gray-700 text-3xl ml-auto "
      />
    </div>
    <div v-if="isOpen && isExpanded" class="ml-8 mt-1 space-y-1">
      <RouterLink
        v-for="(child, idx) in children"
        :key="idx"
        :to="child.to"
        class="flex items-center gap-2 px-6 py-2 rounded hover:bg-gray-100 text-gray-700 text-xs font-normal uppercase"
        active-class="active"
      >
        <Icon :icon="child.icon" class="text-xl text-gray-500" />
        <span class="text-gray-500 font-normal">{{ child.label }}</span>
      </RouterLink>
    </div>
  </div>
</template>

